import { type PropsWithChildren } from "react";
import { clsx } from "clsx";

export const ModalConfirm = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex flex-col items-center gap-y-10 px-5">{children}</div>
  );
};

const ModalConfirmTitle = ({
  children,
  className
}: PropsWithChildren & { className?: string }) => {
  return (
    <p
      className={clsx(
        "whitespace-pre-line text-center text-4xl font-semibold",
        className
      )}
    >
      {children}
    </p>
  );
};

ModalConfirm.Title = ModalConfirmTitle;

const ModalConfirmActionsContainer = ({ children }: PropsWithChildren) => {
  return <div className="flex w-full gap-5">{children}</div>;
};

ModalConfirm.ActionsContainer = ModalConfirmActionsContainer;
